import { errorHandler } from '@/services/toastHandler'

const initState = () => ({
  loading: false,
  error: {},
})

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOADING: s => Object.assign(s, initState(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: s => (s.loading = false),
    RESET: s => Object.assign(s, initState()),
  },

  actions: {
    async changePasswordAsync({ commit }, payload) {
      commit('RESET')
      commit('LOADING')
      try {
        const res = await this.$api.put(`/portal/users/${payload.userId}/reset-password`, {
          password: payload.password,
        })
        if (res?.data?.data === true) { return true }
      } catch (e) {
        errorHandler(e)
      } finally {
        commit('LOADED')
      }
    },
  },
}
